import { Dialog } from '@base-ui/react/dialog';
import { useFeedback } from '../state/feedback.ts';
import { Button } from './Button.tsx';

/** One toast (polite live region) and one modal dialog at a time. docs/spec/06 §3. */
export function FeedbackHost() {
  const toast = useFeedback((s) => s.toast);
  const dialog = useFeedback((s) => s.dialog);
  return (
    <>
      <div
        aria-live="polite"
        className="pointer-events-none fixed inset-x-0 z-[60] flex justify-center px-4"
        style={{ bottom: 'calc(var(--safe-bottom) + 24px)' }}
      >
        {toast ? (
          <div
            key={toast.id}
            role={toast.tone === 'error' ? 'alert' : 'status'}
            className={`max-w-[520px] rounded-full border bg-surface2 px-5 py-3 t-label shadow-[var(--shadow-panel)] ${
              toast.tone === 'error'
                ? 'border-danger'
                : toast.tone === 'success'
                  ? 'border-success'
                  : 'border-border-strong'
            }`}
            style={{ animation: 'toast-in 180ms ease-out' }}
          >
            {toast.message}
          </div>
        ) : null}
      </div>
      <Dialog.Root open={!!dialog} onOpenChange={(open) => !open && dialog?.resolve(null)}>
        <Dialog.Portal>
          <Dialog.Backdrop className="fixed inset-0 z-[70] bg-scrim" />
          <Dialog.Popup className="fixed top-1/2 left-1/2 z-[71] w-[calc(100vw-32px)] max-w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-xl border border-border bg-surface p-6 shadow-[var(--shadow-panel)] outline-none">
            {dialog ? (
              <div className="flex flex-col gap-4">
                <Dialog.Title className="t-title">{dialog.title}</Dialog.Title>
                {dialog.message ? (
                  <Dialog.Description className="t-body text-dim">{dialog.message}</Dialog.Description>
                ) : null}
                <div className="flex flex-col gap-2">
                  {dialog.actions.map((a) => (
                    <Button
                      key={a.label}
                      variant={a.variant ?? 'secondary'}
                      full
                      onClick={() => dialog.resolve(a.value)}
                    >
                      {a.label}
                    </Button>
                  ))}
                </div>
              </div>
            ) : null}
          </Dialog.Popup>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
}
